import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Http } from '@angular/http';
import { Platform } from 'ionic-angular';

import { helpers } from '../helpers';
import { MULTIPLE_REQUESTS, TIMEOUT_REQUEST_SECS, TIMEOUT_REQUEST_SECS_IN_MULTIPLE_REQ_MODE } from '../constants';

const LOCAL_ID_COOKIE_NAME = 'localID';
const CSIMK = 'csimk';
const LOCAL_ID_COOKIE_EXPIRES = 129600; // minutes 90days

@Injectable()
export class Utils {
  private localIP: string | null = null;
  private localID: string;
  private csimk: string;
  private isCordova: boolean;
  private isElectron: boolean;

  constructor(
    private plt: Platform,
    private http: Http
  ) {
    Object.assign(this, helpers);

    // init local vars
    this.setLocalIP();
    this.setLocalID();
    this.setCSIMK();

    // cordova
    this.isCordova = this.plt.is('cordova');
    this.isElectron = window && window['process'] && window['process'].type;
  }

  public getLocalIP(){
    return this.localIP;
  }

  private setLocalIP(){
    let self = this;
    try {
      window['RTCPeerConnection'] = window['RTCPeerConnection'] || window['mozRTCPeerConnection'] || window['webkitRTCPeerConnection']; //compatibility for Firefox and chrome
      var pc: any = new window['RTCPeerConnection']({ iceServers: [] }), noop = function () { };
      if(pc.createDataChannel){
        pc.createDataChannel('');//create a bogus data channel
        pc.createOffer(pc.setLocalDescription.bind(pc), noop);// create offer and set local description
        pc.onicecandidate = function (ice) {
          if (ice && ice.candidate && ice.candidate.candidate) {
            var myIP = /([0-9]{1,3}(\.[0-9]{1,3}){3}|[a-f0-9]{1,4}(:[a-f0-9]{1,4}){7})/.exec(ice.candidate.candidate);
            if (myIP && typeof myIP[1] !== 'undefined') {
              self.localIP = myIP[1];
            }
            pc.onicecandidate = noop;
          }
        };
      }
    } catch(err) {
      console.log(err);
    }
  }

  public getLocalID(){
    return this.localID;
  }

  public getCSIMK(){
    return this.csimk;
  }

  private setLocalID(){
    let localID = helpers.getCookie(LOCAL_ID_COOKIE_NAME);
    if(!localID){
      localID = helpers.generateLocalID();
      helpers.setCookie(LOCAL_ID_COOKIE_NAME, localID, LOCAL_ID_COOKIE_EXPIRES);
    }
    this.localID = localID;
  }

  private setCSIMK() {
    this.csimk = helpers.getCookie(CSIMK);
  }

  public isMobile(){
    return this.isCordova;
  }

  public isWeb(){
    return !this.isCordova;
  }

  public isDesktop(){
    return this.isElectron;
  }

  get$(url, options?) {
    return this.http
      .get(url, options);
  }

  pausableTimer$(pauser: Observable<any>, startFrom?: number): Observable<number> {
    return Observable.create((obs) => {
      let i = startFrom || 0
        , ticker = Observable.interval(1000).map(() => i++);
      let pausable = pauser.switchMap(pause =>
        pause ? Observable.never() : ticker);

      return pausable.subscribe(
        val => obs.next(val),
        err => obs.error(err),
        () => obs.complete());
    });
  }

  resettableTimer$(
    resetter: Observable<any>,
    pauser?: Observable<any>,
    startFrom?: number): Observable<any> {
    let pause = pauser || Observable.empty()
      .startWith(false);

    return resetter
      .switchMap(active => active
        ? this.pausableTimer$(pause, startFrom)
        : Observable.empty());
  }

  resettableCountDown$(
    resetter: Observable<any>,
    timeInSecs: number,
    isResettableAfterDown?: boolean,
    startFrom?: number): Observable<any> {
    let result$ = this.resettableTimer$(resetter);

    let startTimeCountdown$ = result$
      .filter(x => x === 0)
      .map(() => {
        let current = new Date();

        if (startFrom) {
          current.setSeconds(current.getSeconds() - startFrom);
        }

        return current;
      });

    let return$ = isResettableAfterDown
      ? result$
      .withLatestFrom(startTimeCountdown$)
      .filter(([, startTime]) => helpers
        .differenceInSecondsBetweensDates(startTime, new Date()) < timeInSecs)
      : result$
      .withLatestFrom(startTimeCountdown$)
      .takeWhile(([, startTime]) => helpers
        .differenceInSecondsBetweensDates(startTime, new Date()) < timeInSecs);

    return return$
      .map(([, startTime]) => helpers
        .differenceInSecondsBetweensDates(startTime, new Date()) + 1);
  }

  requestTimeout$(valueToEmit?, customTimeoutSecs?): Observable<any> {
    if (typeof customTimeoutSecs === 'undefined') {
      customTimeoutSecs = MULTIPLE_REQUESTS ? TIMEOUT_REQUEST_SECS_IN_MULTIPLE_REQ_MODE : TIMEOUT_REQUEST_SECS;
    }
    return Observable.timer(0, 1000)
      .filter(current => current + 1 > customTimeoutSecs)
      .take(1)
      .mapTo(valueToEmit);
  }

  deepAssign(...args: any[]) { }
  immutAssign(dest, source, value) { }
  isEmptyObject(obj) { }
  disabledEventPropagation(event) { }
  getObjectsByKey(key, values) { }
  getNewObjectInDeepCamelCase(oldObj, isArray?) { }
  getNewObjectInCamelCase(oldObj) { }
  isFunction(value) { }
  isObject(value) { }
  isArray(value) { }
  isWindow(obj) { }
  isPlainObject(obj) { }
  pascalCaseToCamelCase(str) { }
  camelCaseToPascalCase(str) { }
  camelCaseToSpaces(str) { }
  dashCaseToCamelCase(str) { }
  snakeCaseToCamelCase(str) { }
  dashCaseToSpaces(str) { }
  generateShortUID() { }
  generateUID(separator?) { }
  differenceInSecondsBetweensDates(date1, date2) { }
  mmssfromSecs(seconds) { }
}



// WEBPACK FOOTER //
// ./src/app/services/utils.service.ts